export function useLoyalties() {
    onMounted(async () => {
        await load()
    })

    const load = async () => {
        await supplierStore.loadLoyalties()
    }

    const loyalties = computed(() => supplierStore.loyalties)
    const activeLoyalties = computed(() => supplierStore.loyalties.filter(({active}) => active))

    return {loyalties, load, activeLoyalties}
}
